import { render, staticRenderFns } from "./validate.vue?vue&type=template&id=02e139c0&scoped=true"
import script from "./validate.vue?vue&type=script&lang=js"
export * from "./validate.vue?vue&type=script&lang=js"
import style0 from "./validate.vue?vue&type=style&index=0&id=02e139c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e139c0",
  null
  
)

export default component.exports